module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Collapse', {
    model: {
      value: (_vm.isOpen),
      callback: function($$v) {
        _vm.isOpen = $$v
      },
      expression: "isOpen"
    }
  }, [_c('Panel', {
    attrs: {
      "name": "open"
    }
  }, [_vm._v("\n      内容配置\n      "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('el-form', {
    ref: "formCustom",
    attrs: {
      "inline": true,
      "label-width": "125px",
      "model": _vm.contentInfo
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "完整原音: "
    }
  }, [_c('el-row', {
    staticClass: "row-bg",
    staticStyle: {
      "width": "450px"
    },
    attrs: {
      "type": "flex"
    }
  }, [(
    _vm.contentInfo.audio != undefined && _vm.contentInfo.audio != ''
  ) ? _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('AudioPlayer', {
    attrs: {
      "audioUrl": _vm.contentInfo.audio
    }
  })], 1) : _vm._e(), _vm._v(" "), (
    _vm.contentInfo.audio != undefined && _vm.contentInfo.audio != ''
  ) ? _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [(_vm.contentInfo.duration != null) ? _c('span', {
    staticStyle: {
      "font-size": "13px",
      "margin-right": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v("时长：" + _vm._s(_vm.contentInfo.duration) + "秒")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('Upload', {
    attrs: {
      "action": "/aries-api/resource/upload",
      "accept": "audio/mp3",
      "before-upload": _vm.onBeforeAudioUpload,
      "on-success": _vm.onSuccessAudioUpload,
      "data": _vm.uploadDataAudio,
      "show-upload-list": false,
      "disabled": _vm.doWhatTemp === 'view'
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.doWhatTemp === 'view'
    }
  }, [_vm._v("\n                    上传\n                    "), _c('i', {
    staticClass: "el-icon-upload el-icon--right"
  })])], 1)], 1), _vm._v(" "), (
    _vm.contentInfo.audio != undefined && _vm.contentInfo.audio != ''
  ) ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger",
      "icon": "el-icon-delete",
      "disabled": _vm.doWhatTemp === 'view'
    },
    on: {
      "click": _vm.delAudio
    }
  }, [_vm._v("删除")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "讲解者: "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.doWhatTemp === 'view',
      "placeholder": ""
    },
    model: {
      value: (_vm.contentInfo.artist),
      callback: function($$v) {
        _vm.$set(_vm.contentInfo, "artist", $$v)
      },
      expression: "contentInfo.artist"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "完整讲解: "
    }
  }, [_c('el-row', {
    staticClass: "row-bg",
    staticStyle: {
      "width": "450px"
    },
    attrs: {
      "type": "flex"
    }
  }, [(
    _vm.contentInfo.explainAudio != undefined &&
    _vm.contentInfo.explainAudio != ''
  ) ? _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('AudioPlayer', {
    attrs: {
      "audioUrl": _vm.contentInfo.explainAudio
    }
  })], 1) : _vm._e(), _vm._v(" "), (
    _vm.contentInfo.explainAudio != undefined &&
    _vm.contentInfo.explainAudio != ''
  ) ? _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [(_vm.contentInfo.explainDuration != null) ? _c('span', {
    staticStyle: {
      "font-size": "13px",
      "margin-right": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v("时长：" + _vm._s(_vm.contentInfo.explainDuration) + "秒")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('Upload', {
    attrs: {
      "action": "/aries-api/resource/upload",
      "accept": "audio/mp3",
      "before-upload": _vm.onBeforeAudioUpload,
      "on-success": _vm.onSuccessExplainAudioUpload,
      "data": _vm.uploadDataAudio,
      "show-upload-list": false,
      "disabled": _vm.doWhatTemp === 'view'
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.doWhatTemp === 'view'
    }
  }, [_vm._v("\n                    上传\n                    "), _c('i', {
    staticClass: "el-icon-upload el-icon--right"
  })])], 1)], 1), _vm._v(" "), (
    _vm.contentInfo.explainAudio != undefined &&
    _vm.contentInfo.explainAudio != ''
  ) ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger",
      "icon": "el-icon-delete",
      "disabled": _vm.doWhatTemp === 'view'
    },
    on: {
      "click": _vm.delExplainAudio
    }
  }, [_vm._v("删除")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (false) ? _c('el-form-item', {
    attrs: {
      "label": "讲解者: "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": _vm.doWhatTemp === 'view'
    },
    model: {
      value: (_vm.contentInfo.artist),
      callback: function($$v) {
        _vm.$set(_vm.contentInfo, "artist", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "contentInfo.artist"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "视频: "
    }
  }, [_c('el-row', {
    staticClass: "row-bg",
    staticStyle: {
      "width": "450px"
    },
    attrs: {
      "type": "flex"
    }
  }, [(_vm.contentInfo.video != '') ? _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('video', {
    ref: "vidioPlayer",
    attrs: {
      "src": _vm.contentInfo.video,
      "controls": "controls",
      "width": "270"
    }
  }, [_vm._v("\n                  浏览器不支持video\n                ")])]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('Upload', {
    attrs: {
      "action": "/aries-api/resource/upload",
      "accept": "video/mp4",
      "before-upload": _vm.onBeforeVideoUpload,
      "on-success": _vm.onSuccessVideoUpload,
      "data": _vm.uploadData,
      "show-upload-list": true,
      "disabled": _vm.doWhatTemp === 'view'
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.doWhatTemp === 'view'
    }
  }, [_vm._v("\n                    上传\n                    "), _c('i', {
    staticClass: "el-icon-upload el-icon--right"
  })])], 1)], 1), _vm._v(" "), (_vm.contentInfo.video != '') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger",
      "icon": "el-icon-delete",
      "disabled": _vm.doWhatTemp === 'view'
    },
    on: {
      "click": _vm.delVideo
    }
  }, [_vm._v("删除")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "视频封面: "
    }
  }, [_c('el-row', {
    staticClass: "row-bg",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "flex"
    }
  }, [(_vm.contentInfo.poster != '') ? _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.contentInfo.poster,
      "width": "80px",
      "height": "80px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('Upload', {
    attrs: {
      "action": "/aries-api/resource/upload",
      "accept": "image/jpeg, image/gif, image/png",
      "before-upload": _vm.onBeforeUpload,
      "on-success": _vm.onSuccessPosterUpload,
      "data": _vm.uploadData,
      "show-upload-list": false,
      "disabled": _vm.doWhatTemp === 'view'
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.doWhatTemp === 'view'
    }
  }, [_vm._v("\n                    上传\n                    "), _c('i', {
    staticClass: "el-icon-upload el-icon--right"
  })])], 1)], 1), _vm._v(" "), (_vm.contentInfo.poster != '') ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger",
      "icon": "el-icon-delete",
      "disabled": _vm.doWhatTemp === 'view'
    },
    on: {
      "click": _vm.delVideoCover
    }
  }, [_vm._v("删除")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (false) ? _c('el-form-item', {
    attrs: {
      "label": "显示模式: "
    }
  }, [_c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "上传的书每页一张图为单页模式，每页有左右两张图为双页模式",
      "placement": "top-start"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": _vm.doWhatTemp === 'view'
    },
    model: {
      value: (_vm.contentInfo.mode),
      callback: function($$v) {
        _vm.$set(_vm.contentInfo, "mode", $$v)
      },
      expression: "contentInfo.mode"
    }
  }, _vm._l((_vm.modeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('br')], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73c8e7b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/book/components/addBook/addBookContent.vue
// module id = 713
// module chunks = 1